import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Form, FormGroup, Popover, PopoverBody, Row, Col  } from 'reactstrap';
import TYPE_OF_CARD from 'assets/images/bank-card.png';
import { reduxForm, Field, getFormValues } from 'redux-form'
import { connect } from 'react-redux';
import { CardNumber, CardHolderName, ExpiryGroup, SaveCardAutoInfo, SaveCardInfo, RenderForm, SelectInput, CellPhoneNumber } from 'components/Common'
import OTPModal from "components/FDModal/card-otp";
import CupCardBeanOTPModal from "components/FDModal/cubCardBean-otp";

import { callSetPayment, callCardMetaDataAPI, callResendOTPAPI, callRedirectToACSAPI, getCardDetailInfo,RedirectRazorPaySubmit } from 'actions/payment';
import { cardFormValidation,cardTypeValidation,cardMinMax } from 'lib/fp-validation'
import { removeWhiteSpaces, alphawithsinglespace, findObj, findAll, isEmptyOrUndefined } from 'lib/fp-utility';
import GlobalLoaderModal from "components/FDModal/global-loader";
import SIBtnORBtn from "components/Common/siProceedBtn";
import DisplayError from "components/FDModal/display-error";

class CardForm extends Component {

    submitForm = this.submitForm.bind(this);
    getCardInfo = this.getCardInfo.bind(this);
    resendOTP = this.resendOTP.bind(this);
    redirectToACS = this.redirectToACS.bind(this);
    closeSelfOTP = this.closeSelfOTP.bind(this);
    canDisplayErrorModal = this.canDisplayErrorModal.bind(this);
    updateIssuerName = this.updateIssuerName.bind(this);
    handleSiEnabledChecked = this.handleSiEnabledChecked.bind(this);
    updateFormatedCardNo = this.updateFormatedCardNo.bind(this);
    updateCvv = this.updateCvv.bind(this);
    getCvv = this.getCvv.bind(this);
    toggleDisableInputs = this.toggleDisableInputs.bind(this);
    validateCardType = this.validateCardType.bind(this);
    getCardType = this.getCardType.bind(this);
    updateMobilePrefix = this.updateMobilePrefix.bind(this)
    validateCupCardOTP = this.validateCupCardOTP.bind(this)
    closeCupCardBeanOTP = this.closeCupCardBeanOTP.bind(this)
    state = {cupAction:"validateCupCardSMS",razorPayRespData:null,cardTypeStatusLoading:false, cardTypeStatus:false,loader: false, readedCardNo: null, cvv_pin: false, canDisplayCardFields: false , cardTypeValidation:false, cupCardBeanOTP:false, paymentRequest:{}}
    cardTypeValidationMesssage = " Mismatch in the card details as per the selected card type. Please enter correct card details.";
    componentDidMount(){
        window.localStorage.removeItem('readedCardNo')
        window.localStorage.removeItem('cardScheme')
        this.props.change('from', this.props.from)
        if(this.props.from==='EMIC'){
            this.props.change("bankName", this.props.bankname)
            this.props.change("bankCode", this.props.bankcode)
            this.props.change("emiTenure", this.props.emitenure)
        }
        if(this.props.from!=='IDC'){
            this.setState({canDisplayCardFields: true})
        }
        this.toggleDisableInputs()
    }

    toggleDisableInputs(){
        const {transactionDetails} = this.props;
        if(this.props.from==='IDC'){
            const idcBank = document.getElementsByName("card[bankName]")[0]
            if(idcBank && idcBank.selectedIndex === 0){
                this.setState({canDisplayCardFields: false})
                this.props.change("card[cardNumber]", '')
                this.props.untouch("card[cardNumber]")
                this.props.change("card[nameOnCard]", '')
                this.props.untouch("card[nameOnCard]")
                this.props.change("card[expMonth]", '')
                this.props.untouch("card[expMonth]")
                this.props.change("card[expYear]", '')
                this.props.untouch("card[expYear]")
                this.props.change("card[cVV]", '')
                this.props.untouch("card[cVV]")
                this.props.change("myCvv", '')
                this.props.untouch("myCvv") 
            }else{
                this.setState({canDisplayCardFields: true})
            }
        }else{
            this.setState({canDisplayCardFields: true})
        }
        // to enable SI 
        if(transactionDetails &&
           transactionDetails.autoDebit 
           ){
            if(transactionDetails.autoDebit === "Y"){
                this.setState({siEnabled: true})
                this.props.change("standingInstruction", true)
                this.props.change("autoDebit","Y")
            }else{
                this.setState({siEnabled: false})
                this.props.change("autoDebit",transactionDetails ?transactionDetails.autoDebit:null)
            }
      
        }
    }

    async getCardType(){
        // const {cardNumber,nameOnCard} = this.props.formValues.card;
        // const {from ,emiCardType} = this.props;
        const { formValues } = this.props
        let cardNo = formValues.card ? formValues.card.cardNumber : null
        const { cardType } = this.state;
        const card_no_with_slice = await removeWhiteSpaces(cardNo);
        const error = cardMinMax(cardType,card_no_with_slice);
        //let typeValidation;
        if(!error){
            this.setState({cardTypeStatusLoading:false, cardTypeStatus:true,cardTypeValidation : true});
            /* this.setState({cardTypeStatusLoading:true,cardTypeStatus:false,cardTypeValidation : false});
            getCardDetailInfo(card_no_with_slice).then((resp) => {
                if(resp && resp.data && resp.data.response){
                    console.log("EMICARDTYPE",emiCardType)
                    if(from === "EMIC" && emiCardType){
                        typeValidation = cardTypeValidation(resp.data.response,emiCardType);
                    }else {
                        typeValidation = cardTypeValidation(resp.data.response,from);
                    }
                    if(typeValidation){
                        this.setState({cardTypeStatusLoading:false, cardTypeStatus:true,cardTypeValidation : true});
                    }else{
                        this.setState({cardTypeStatusLoading:false,cardTypeStatus:true,cardTypeValidation : false});
                    }
                }else{
                    this.setState({cardTypeStatusLoading:false,cardTypeStatus:true,cardTypeValidation : false});
                }
            }).catch((error) => {
                this.setState({cardTypeStatusLoading:false,cardTypeStatus:true,cardTypeValidation : false});
            })*/
        }
    }

    async getCardInfo(cardNumber){
        const card_no = await removeWhiteSpaces(cardNumber);
        const card_no_with_slice = await removeWhiteSpaces(cardNumber);
        const { bankname, bankcode,from } = this.props;
        const bin = card_no.slice(0,6);
        const forMetaData = {card_no:bin,cardNumber:card_no, bankname, bankcode };
        this.getCardType();
        if(card_no.length >= 12 && this.state.readedCardNo !== card_no){
            this.setState({readedCardNo: card_no})
           
            callCardMetaDataAPI(this.props.from, forMetaData)
            .then((resp)=>{
                if(resp.data.response.errorCode){
                    this.setState({cardMetaData: null, cardType: null, dccEnabled: false, dccCard: null})
                    this.canDisplayErrorModal(resp.data.response.errorCode, resp.data.response.errorMessage)
                }else{
                    this.setState({ cardMetaData: resp.data.response, cardType: resp.data.response.cardDetail.cardScheme, dccEnabled: !isEmptyOrUndefined(resp.data.response.dcc), dccCard: resp.data.response.dcc})
                    if(resp.data.response.cardDetail.cardScheme === 'UNIONPAY'){
                        this.props.change("cupCardBean", true)
                    }
                }
            })
        }else if(card_no.length < 6 && this.state.cardMetaData){ // Reset collected CardInfo
            this.setState({cardTypeStatus:false,cardTypeValidation : true,
                cardMetaData: null, cardType: null, readedCardNo: null, dccEnabled: false, dccCard: null})
        }
    }

    async submitForm(cardForm) {
        this.setState({loader: true, paymentRequest: cardForm})
        let setPaymentData = { cardForm }
        if(this.props.from==='IDC'){
            const selectedBank = findObj(this.props.bankList, cardForm.card.bankName, 'bankCode')
            setPaymentData = { ...setPaymentData, selectedBank }
        }
        if(cardForm.cardScheme === "UNIONPAY" && this.state.cupAction === "validateCupCardSMS"){
            cardForm.cupCardBean = {...cardForm.cupCardBean,action:this.state.cupAction }
        }

        this.props.callSetPayment(this.props.from, setPaymentData, this.props.txnKey, this.props.txnIv).then((resp) =>{
            this.setState({paymentResponse: resp.payload.data})

            const { razorPayOrderResponseBean, errorCode,
                 errorMessage, iDebitUrl, selfOTPBin, selfOTPTermUrl,
                  is3DSecure, isRupayCard, threeDSecureRequest,
                   rupayCardRequestBean, cupCardResponseBean } = resp.payload.data
            const non3DSecure = !(selfOTPBin || is3DSecure || isRupayCard)
            this.setState({iDebitUrl, is3DSecure, selfOTPBin, selfOTPTermUrl, isRupayCard, threeDSecureRequest, rupayCardRequestBean, non3DSecure})     
            if(errorCode){
                this.setState({loader: false})
               this.canDisplayErrorModal(errorCode, errorMessage)
            } else if(selfOTPBin){
                this.setState({loader: false})
            } else if(is3DSecure){
                this.setState({redirectingTOBank: true})
                if(!threeDSecureRequest.is3ds2Integration) {
                    document.ACSFORM.submit();
                } else {
                    if(threeDSecureRequest.tdsFlow === 'CHL') {
                        document.creq.submit();
                    }
                }
            }
            else if(iDebitUrl){
                this.setState({redirectingTOBank: true})
                document.IDEBITFORM.submit();
            }
            else if(razorPayOrderResponseBean && razorPayOrderResponseBean.method === 'CARD'){  
                RedirectRazorPaySubmit(razorPayOrderResponseBean).then((getRazorPayResponse)=>{
					this.setState({razorPayRespData: getRazorPayResponse})
				})
               // console.log("RESP",razorPayOrderResponseBean)
            }
            else if(cupCardResponseBean && cupCardResponseBean.isCupSMSSent) {
                this.setState({cupCardBeanOTP: true,loader: false})
            }
            else if(cupCardResponseBean && cupCardResponseBean.SMSVerifiedFlag) {

                this.setState({cupAction:'authorizeCupCardTran', loader: false}, () => { 
                    let response = this.state.paymentRequest
                    response.cupCardBean = {action:'authorizeCupCardTran' }
                    this.submitForm(response)       
                 });

            }            
             else if(non3DSecure){
                this.setState({non3DSecureUrl: resp.payload.data.redirectUrl, redirectingTOBank: true})
                document.NON3DSECUREFORM.submit();
            }
        }).catch((error)=>{
            this.setState({loader: false})
        });
    }
    
    resendOTP(){
        this.setState({disableOTPBtn: true})
        callResendOTPAPI().then((resp)=>{
            this.setState({disableOTP: resp.STATUS==='SUCCESS'})
        })
    }

    redirectToACS(){
        this.setState({loader: true})
        callRedirectToACSAPI().then((resp)=>{
            const { is3DSecure, threeDSecureRequest } = resp.data
            this.setState({is3DSecure, threeDSecureRequest})
            if(resp.data.errorCode){
                this.setState({loader: false})
            }else if(is3DSecure){
                //document.ACSFORM.submit();
                if(!threeDSecureRequest.is3ds2Integration) {
                    document.ACSFORM.submit();
                } else {
                    if(threeDSecureRequest.tdsFlow === 'CHL') {
                        document.creq.submit();
                    }
                }
            }
        })
    }

    closeSelfOTP(){
        this.setState({selfOTPBin: false, disableOTPBtn: false})
    }
    closeCupCardBeanOTP(){
        this.setState({cupCardBeanOTP:false})
    }

    handleSiEnabledChecked(e){
        this.setState({siEnabled: !this.state.siEnabled}, () =>{
            if(this.state.siEnabled){
                this.props.change("autoDebit","Y")
            } else {
                this.props.change("autoDebit","N")
            }
        })
    }

    canDisplayErrorModal(errCode, errMsg){
        if(errCode==='FPDR4025'){
            this.setState({displayError: true, errMsg})
        }
    }

    updateIssuerName(e){
        this.toggleDisableInputs()
        if(!e.target.value){
            this.setState({cardType: null})
        }
        /* Don't wanted to get e.target.value because we will translate so at that time we will get different text. */
        const issuerName = e.target.options[e.target.selectedIndex].getAttribute("issuername")
        this.props.change("bankIssuerName",issuerName)
    }

    updateMobilePrefix(e){
        const mobilePrefix = e.target.options[e.target.selectedIndex].getAttribute("value")
        this.setState({stdCode:mobilePrefix})
        this.props.change("cardScheme",this.state.cardType)

    }

    toggleCvvPop = () => {
        this.setState({ cvv_pin: !this.state.cvv_pin });
    }

    updateCvv(v){
        if(v.length === 1){
            this.getCardType();
        }
        this.props.change("card[cVV]", v)
    }

    getCvv(v){
        return this.props.formValues.card.cVV===undefined ? '' : this.props.formValues.card.cVV
    }

    updateFormatedCardNo(formatedCardNo){
        //formatedCardNo ="5204740000002729";
        this.props.change("card[cardNumber]", formatedCardNo)
    }

  validateCardType(value ){
    return (!this.state.cardTypeValidation && this.state.cardTypeStatus && this.state.cardType) ? this.cardTypeValidationMesssage: ""

    }

    validateCupCardOTP(otp, response){
        this.setState({cupAction:'verifyCupCardSMS'}, () => { 
            response.cupCardBean = {action:'verifyCupCardSMS', smsNo: otp }
            this.submitForm(response)       
         });
    }


    render() {
        const {cardTypeValidationMesssage} =  this;
        const {cardTypeValidation,cardTypeStatus,cardTypeStatusLoading} = this.state;
        const { t, handleSubmit, pristine, submitting, invalid, change, untouch, touch, from,transactionDetails } = this.props;
        const selectBankOptions =  this.props.bankList.map((data) => ({'displayName': data.bankName, 'value': data.bankCode}))
        const selectPhonePrefix = [{'displayName': '+60', 'value': '60'},{'displayName': '+61', 'value': '61'},{'displayName': '+64', 'value': '64'},{'displayName': '+65', 'value': '65'},{'displayName': '+91', 'value': '91'},{'displayName': '+852', 'value': '852'}]
        const errorMessage = !cardTypeStatusLoading ?(!cardTypeValidation && cardTypeStatus) ? cardTypeValidationMesssage:"" : "Checking card details";
        return(
            <>
             <div style={{display:"none"}}>{this.state.cardTypeValidation}</div>
                <Form onSubmit={handleSubmit(this.submitForm)} name='cardForm' autoComplete='off'>
                    <figure className="text-center">
                        <img src={TYPE_OF_CARD} alt="card" title="" />
                    </figure>
                    <Field type='hidden' name="from" component='input' />
                    <Field name="card[cVV]" type='hidden' component="input" />
                    {
                        from==='EMIC' && (
                            <>
                                <Field name="bankName" type='hidden' component="input" />
                                <Field name="bankCode" type='hidden' component="input" />
                                <Field name="emiTenure" type='hidden' component="input" />
                            </>
                        )
                    }
                    {
                        this.props.from==='IDC' &&
                        <FormGroup className="custom-dd">
                            <Field name="card[bankName]" onChange={this.updateIssuerName} component={SelectInput} blank='---Select Bank---' options={selectBankOptions} className="form-control" />
                            <Field name="bankIssuerName" type='hidden' component='input' />
                        </FormGroup>
                    } 
                    {
                        this.state.canDisplayCardFields &&
                        <>
                            <CardNumber
                                updateFormatedCardNo={this.updateFormatedCardNo}
                               onBlur={(e) => this.getCardInfo(e.target.value)}
                                cardType={this.state.cardType}
                               validateCardType ={this.validateCardType} 
                            />
                            {/* {(!this.state.cardTypeValidation && this.state.cardTypeStatus ) &&
                                <label className="error">
                                    Mismatch in the card details as per the selected card type. Please enter correct card details. 
                                </label>
                            } */}
                            <CardHolderName 
                                info={this.state.cardType==='MAESTRO'} 
                                normalize={(value, preVal) => alphawithsinglespace(value, preVal)}
                            />
                            {
                                this.state.cardType === 'UNIONPAY' &&
                                <Row form>
                                <Col md={4}>
                                <Field name="card[cardType]" type='hidden' value={this.state.cardType} component='input' />
                                <FormGroup className="mb-4 auto-height">
                                    <Field name="cupCardBean[stdCode]" selectValue= {this.state.stdCode} onChange={this.updateMobilePrefix} component={SelectInput} blank='---Std Code---' options={selectPhonePrefix} className="form-control reset-border" />
                                    <Field name="mobilePrefix" type='hidden' component='input' />

                                </FormGroup>
                                </Col>
                                <Col md={8}>
                                <FormGroup className="mb-4 auto-height">
                                    {/* <Field name="cupCardBean[action]" value={this.state.cupAction} type='hidden' component='input' /> */}
                                    <Field name="cupCardBean[mobileNo]" fieldName="cupCardBean[mobileNo]" className="form-control" component={CellPhoneNumber} />
                                </FormGroup>
                                </Col>
                                </Row>
                            }                              
                            <ExpiryGroup 
                                from={this.props.from} 
                                cardType={this.state.cardType} 
                                onMouseEnter={this.toggleCvvPop}
                                onMouseLeave={this.toggleCvvPop}
                                updateCvv={this.updateCvv}
                                getCvv={this.getCvv}
                            />
                            <Popover placement="bottom"  isOpen={this.state.cvv_pin} target={'cvvInfo'}>
                                <PopoverBody><p className="text-13">The CVV number is the last three digits at the back of your card. For American Express cards, the CVV is a 4 digit number on the front of the card</p></PopoverBody>
                            </Popover>
                        </>
                    }

                    {transactionDetails.autoDebit != "Y" && this.props.siEnabled && (this.props.from==='CC' || this.props.from==='DC' )  && !this.state.dccEnabled &&
                        <SaveCardAutoInfo 
                            t={t} 
                            checked={this.state.siEnabled}
                            onChange={this.handleSiEnabledChecked}
                        />
                    }

                    { this.props.canDisplaySaveCard && this.props.mCardVaultEnabled && <SaveCardInfo t={t}/> }
                  
                     <SIBtnORBtn disabled={invalid|| submitting || pristine || 
                     this.state.loader || 
                     (!cardTypeValidation && cardTypeStatus) || cardTypeStatusLoading
                   || !this.props.termsStatus } t={t}
                     change={change}
                     untouch={untouch}
                     touch={touch}
                     formValues={this.props.formValues}
                     cardMetaData={this.state.cardMetaData}
                     siEnabled={this.state.siEnabled}
                     dccEnabled={this.state.dccEnabled}
                     dccCard={this.state.dccCard}
                     errorMessage= {errorMessage}
                     from={this.props.from}
                     transactionDetails={this.props.transactionDetails}
                     selectedEMIOption={this.props.selectedEMIOption}
                     backLink={this.props.backLink!=='noNeed'}
                 />
                </Form>
                { this.state.loader &&  <GlobalLoaderModal transaction={this.state.redirectingTOBank} /> }
                { this.state.displayError &&  <DisplayError errMsg={this.state.errMsg} /> }
                { this.state.selfOTPBin && <OTPModal paymentResponse={this.state.paymentResponse} selfOTPTermUrl={this.state.selfOTPTermUrl} resendOTP={this.resendOTP} modalClassName="custom-otp-popup errorInvalid-popup" disableOTPBtn={this.state.disableOTPBtn} closeSelfOTP={this.closeSelfOTP} redirectToACS={this.redirectToACS} change={change} /> }
                { this.state.cupCardBeanOTP && <CupCardBeanOTPModal paymentRequest={ this.state.paymentRequest } paymentResponse={this.state.paymentResponse} modalClassName="custom-otp-popup errorInvalid-popup" disableOTPBtn={this.state.disableOTPBtn} closeSelfOTP={this.closeCupCardBeanOTP}  validateOTP={this.validateCupCardOTP} /> }

                <div className='hidden'>
                    <RenderForm razorPayRespData={this.state.razorPayRespData} iDebitUrl={this.state.iDebitUrl} is3DSecure={this.state.is3DSecure} isRupayCard={this.state.isRupayCard} threeDSecureRequest={this.state.threeDSecureRequest} rupayCardRequestBean={this.state.rupayCardRequestBean} formName={this.props.from} non3DSecure={this.state.non3DSecure} non3DSecureUrl={this.state.non3DSecureUrl} />
                </div>
            </> 
        );
    }
}

const CForm = reduxForm({
    form: 'cardForm',
    validate: cardFormValidation
})(CardForm)

const mapStateToProps = state => {
    const formValues = getFormValues("cardForm")(state) || {};
    const {termsStatus, saveInfo: vaultCard, transactionDetails, txnKey, txnIv, siEnabled, globalConfig: { mConfig:  {lstMerchBank,mCardVaultEnabled}} } = state.fdData
    let returnProps = {termsStatus, transactionDetails, txnKey, txnIv, siEnabled,mCardVaultEnabled, initialValues: {card: {vaultCard}}, formValues, bankList: findAll(lstMerchBank, 'FSS', 'channelName') }
    return returnProps
}

export default withTranslation('translations') (connect(mapStateToProps, { callSetPayment })(CForm));